// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__236eH","inner":"Footer_inner__36qSy","nextIcon":"Footer_nextIcon__1ujqF","innerLeft":"Footer_innerLeft__N8hOR"};